import appEnv from 'bundles/onboarding-2022/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
